import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FlexboxColumn } from '../../components/action/Flexbox';
import ButtonApi from '../../components/ButtonApi';
import ThemedText from '../../components/theme/ThemedText';
import { PodStateProvider } from '../../helpers/podHelper';
import { useGlobalState } from '../../state/GlobalStateProvider';
import './Identity.scss';
const IdentityWrapper = () => {
  const history = useNavigate();
  const [{ user }] = useGlobalState();
  const ADMIN = [
    '0x3a86e9c1947f9ff49abf2bcc3301008165636a5d',
    '0xc28de126e148361cad06a235eb39651652360ba0',
    '0x6a9abb446fca45dc9be5fa3051c4167cd96d1f99',
    '0xb6fbf1cc3a397815c7c00a83a2063782eafd1036',
  ];


  async function checkEligibility() {
    const response = true;
    if (response) {
      history('/eligibility');
    }
  }

  return (
    <FlexboxColumn className='identity_wrapper' gap='2rem' alignItems={'center'}>
      <FlexboxColumn fw gap='1.5rem' alignItems={'center'}>
        <FlexboxColumn gap='0' fw>
          <ThemedText.H2>HumanED Pod</ThemedText.H2>
          <ThemedText.H5>Human verification engine for the people of Mars and beyond. </ThemedText.H5>
        </FlexboxColumn>
        {ADMIN.includes(String(user?.address)?.toLowerCase()) && (
          <ButtonApi className='unfair' onClick={checkEligibility}>
            <ThemedText.P>Access Portal</ThemedText.P>
          </ButtonApi>
        )}

        {/* <Flexbox fw justifyContent='space-between'>
          <Flexbox gap='0.25rem'>
            <ThemedText.H5>0/5 Peers connected</ThemedText.H5>
            <ThemeLogo icon={'info'} />
          </Flexbox>
          <button className='identity_wrapper__button' onClick={requestConnection}>
            Request Connection
          </button>
        </Flexbox> */}
      </FlexboxColumn>
      <img className='identity_wrapper__pod' src={require('../../assets/images/device.png')} />
      {/* <PodWrapper>{STEPS[0]}</PodWrapper> */}
    </FlexboxColumn>
  );
};

const Identity = () => {
  return (
    <PodStateProvider>
      <IdentityWrapper />
    </PodStateProvider>
  );
};

export default Identity;
